import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Bell } from 'lucide-react';
import { notificationService } from '../../services/api';

/**
 * Resumo da central in-app no dashboard (invalidação via SSE no layout; polling 5 min como fallback).
 */
const NotificationCenterCard = () => {
  const { data: unreadRes } = useQuery(
    ['notifications-unread-count'],
    () => notificationService.getInAppUnreadCount().then((r) => r.data),
    { refetchInterval: 300_000, refetchOnWindowFocus: true }
  );
  const { data: listRes } = useQuery(
    ['notifications-in-app-preview'],
    () => notificationService.listInApp({ limit: 5, skip: 0 }).then((r) => r.data),
    { refetchInterval: 300_000, refetchOnWindowFocus: true }
  );

  const unread = unreadRes?.unread_count ?? 0;
  const items = listRes?.data ?? [];

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-soft">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Bell className="h-5 w-5 text-primary-600" />
          <h2 className="text-lg font-semibold text-gray-900">Central de notificações</h2>
        </div>
        {unread > 0 ? (
          <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-semibold text-primary-800">
            {unread} nova{unread !== 1 ? 's' : ''}
          </span>
        ) : (
          <span className="text-xs text-gray-500">Em dia</span>
        )}
      </div>
      <p className="mb-4 text-sm text-gray-600">
        Agentes de <strong>fiscalização</strong> (prazos de licenças e condicionantes) e de{' '}
        <strong>controle</strong> (processos em aberto) geram alertas de forma assíncrona.
      </p>
      <ul className="mb-4 space-y-2">
        {items.slice(0, 5).map((n) => (
          <li key={n.id} className="text-sm text-gray-800">
            <span className="font-medium text-gray-900">{n.title}</span>
            {!n.read_at ? <span className="ml-2 text-xs text-primary-600">novo</span> : null}
          </li>
        ))}
        {items.length === 0 ? (
          <li className="text-sm text-gray-500">Nenhum alerta recente.</li>
        ) : null}
      </ul>
      <Link to="/notifications" className="btn btn-primary btn-sm inline-flex items-center gap-2">
        Ver central completa
      </Link>
    </div>
  );
};

export default NotificationCenterCard;
